export default "__VITE_ASSET__Bxaqo9J8__ 600w";